export default {
    'PREGÃO ELETRÔNICO': 'Pregão Eletrônico',
    'CONCORRÊNCIA ELETRÔNICA': 'Concorrência Eletrônica',
    'CREDENCIAMENTO': 'Credenciamento',
    'LEILÃO ELETRÔNICO': 'Leilão Eletrônico',
    'PREGÃO PRESENCIAL': 'Pregão Presencial',
    'DIÁLOGO COMPETITIVO': 'Diálogo Competitivo',
    'CONCURSO': 'Concurso',
    'CONCORRÊNCIA PRESENCIAL': 'Concorrência Presencial',
    'MANIFESTAÇÃO DE INTERESSE': 'Manifestação de Interesse',
    'PRÉ QUALIFICAÇÃO': 'Pré Qualificação',
    'LEILÃO PRESENCIAL': 'Leilão Presencial',
    'INAPLICABILIDADE DA LICITAÇÃO': 'Inaplicabilidade da Licitação',
    'ESTATAIS DISPUTA ABERTA PRESENCIAL' : 'Estatais Disputa Aberta Presencial',
    'ESTATAIS DISPUTA ABERTA ELETRÔNICA' : 'Estatais Disputa Aberta Eletrônica',
    'ESTATAIS DISPUTA FECHADA PRESENCIAL' : 'Estatais Disputa Fechada Presencial',
    'ESTATAIS DISPUTA FECHADA ELETRÔNICA' : 'Estatais Disputa Fechada Eletrônica',
    'ESTATAIS DISPUTA COMBINADA PRESENCIAL' : 'Estatais Disputa Combinada Presencial',
    'ESTATAIS DISPUTA COMBINADA ELETRÔNICA' : 'Estatais Disputa Combinada Eletrônica'

}
